import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { api } from "../../api";

function AddForm({ onUpdate, activeTab }) {
  const [regNr, setRegNr] = useState('');
  const [inspectionDate, setInspectionDate] = useState('');

  const [name, setName] = useState('');
  const [ssgApplied, setSsgApplied] = useState('');
  const [lkabApplied, setLkabApplied] = useState('');

  const handleVehicleSubmit = async e => {
    e.preventDefault();
    await api.post('/vehicles', { regNr, inspectionDate });
    setRegNr('');
    setInspectionDate('');
    onUpdate();
  };

  const handleEmployeeSubmit = async e => {
    e.preventDefault();
    await api.post('/employees', { name, ssgApplied, lkabApplied });
    setName('');
    setSsgApplied('');
    setLkabApplied('');
    onUpdate();
  };

  if (activeTab === 'vehicles') {
    return (
      <div className="container mt-4">
        <h5>Lägg till fordon</h5>
        <Form onSubmit={handleVehicleSubmit}>
          <Form.Group>
            <Form.Label>Fordon</Form.Label>
            <Form.Control value={regNr} onChange={e => setRegNr(e.target.value)} required />
          </Form.Group>
          <Form.Group>
            <Form.Label>Besiktningsdatum</Form.Label>
            <Form.Control type="date" value={inspectionDate} onChange={e => setInspectionDate(e.target.value)} required />
          </Form.Group>
          <Button type="submit" variant="success" className="mt-2">Lägg till</Button>
        </Form>
      </div>
    );
  }

  if (activeTab === 'employees') {
    return (
      <div className="container mt-4">
        <h5>Lägg till anställd</h5>
        <Form onSubmit={handleEmployeeSubmit}>
          <Form.Group>
            <Form.Label>Namn</Form.Label>
            <Form.Control value={name} onChange={e => setName(e.target.value)} required />
          </Form.Group>
          <Form.Group>
            <Form.Label>SSG ansökt (valfritt)</Form.Label>
            <Form.Control type="date" value={ssgApplied} onChange={e => setSsgApplied(e.target.value)} />
          </Form.Group>
          <Form.Group>
            <Form.Label>LKAB ansökt (valfritt)</Form.Label>
            <Form.Control type="date" value={lkabApplied} onChange={e => setLkabApplied(e.target.value)} />
          </Form.Group>
          <Button type="submit" variant="success" className="mt-2">Lägg till</Button>
        </Form>
      </div>
    );
  }

  return null;
}

export default AddForm;
